import { render, staticRenderFns } from "./tnc-mm.vue?vue&type=template&id=f1dd4816&scoped=true"
import script from "./tnc-mm.vue?vue&type=script&lang=js"
export * from "./tnc-mm.vue?vue&type=script&lang=js"
import style0 from "./tnc-mm.vue?vue&type=style&index=0&id=f1dd4816&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dd4816",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1dd4816')) {
      api.createRecord('f1dd4816', component.options)
    } else {
      api.reload('f1dd4816', component.options)
    }
    module.hot.accept("./tnc-mm.vue?vue&type=template&id=f1dd4816&scoped=true", function () {
      api.rerender('f1dd4816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-mm.vue"
export default component.exports